import { render, staticRenderFns } from "./unityCenter.vue?vue&type=template&id=473aca5c&scoped=true"
import script from "./unityCenter.vue?vue&type=script&lang=js"
export * from "./unityCenter.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/lib/unityCenter.scss?vue&type=style&index=0&id=473aca5c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473aca5c",
  null
  
)

export default component.exports